<template>
  <div>
    <label for="styleOptions">Style:</label>
    <div id="styleOptions" class="btn-group" role="group">
      <input
        v-for="motor in options"
        :key="motor.id"
        type="radio"
        class="btn-check"
        :name="name"
        :id="motor.id"
        :value="motor.id"
        v-model="selected"
      />
      <label
        v-for="motor in options"
        :key="motor.id"
        class="btn btn-outline-primary"
        :for="motor.id"
      >
        {{ motor.name }}
      </label>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';

const props = defineProps({
  options: Array,
  name: String,
  modelValue: String
});

const emits = defineEmits(['update:modelValue']);

const selected = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
  selected.value = newValue;
});

watch(selected, (newValue) => {
  emits('update:modelValue', newValue);
});
</script>

<style scoped>
/* Add any specific styles here */
</style>
